import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-047c97f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "py-5 d-flex justify-content-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "fw-bold mb-3 text-center title" }
const _hoisted_6 = { class: "row mx-0 mb-5 shadow-lg bg-white p-3 p-lg-5 rounded-4 mx-auto" }
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = { class: "row mx-0 px-0 gx-3 mb-3" }
const _hoisted_9 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_10 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_11 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_12 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_13 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_14 = { class: "w-max-content col-lg-2 col-form-label text-left text-lg-end" }
const _hoisted_15 = { class: "col-lg-10" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_19 = { class: "w-max-content col-lg-2 col-form-label text-left text-lg-end" }
const _hoisted_20 = { class: "col-lg-10" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_23 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_24 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_25 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_26 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_27 = { class: "w-max-content col-lg-2 col-form-label text-left text-lg-end" }
const _hoisted_28 = { class: "col-lg-10" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_31 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_32 = { class: "w-max-content col-lg-2 col-form-label text-left text-lg-end" }
const _hoisted_33 = { class: "col-lg-10" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_36 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_37 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_38 = { class: "row mx-0 px-0 col-lg-9" }
const _hoisted_39 = { class: "col-lg-12 d-flex align-items-center" }
const _hoisted_40 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_41 = { class: "w-max-content col-lg-3 col-form-label" }
const _hoisted_42 = { class: "row mx-0 px-0 col-lg-9" }
const _hoisted_43 = { class: "text-break" }
const _hoisted_44 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_45 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_46 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_47 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_48 = { class: "col-lg-7" }
const _hoisted_49 = { class: "input-group mb-2" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_51 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_52 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_53 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_54 = {
  id: "phone-number",
  class: "row mx-0 px-0 col-lg-4"
}
const _hoisted_55 = { class: "d-flex" }
const _hoisted_56 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center align-self-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_58 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 px-lg-0 text-center align-self-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "hyphen-position" }, " - ")
], -1))
const _hoisted_60 = { class: "col-lg-3 px-2 px-lg-0" }
const _hoisted_61 = { class: "row mx-0 px-0 gx-3 mb-3" }
const _hoisted_62 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_63 = { class: "row mx-0 px-0 gx-3 mb-2" }
const _hoisted_64 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_65 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_66 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_67 = { class: "col-lg-12" }
const _hoisted_68 = ["value"]
const _hoisted_69 = ["placeholder"]
const _hoisted_70 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3" }, null, -1))
const _hoisted_72 = { class: "col-lg-9 px-3" }
const _hoisted_73 = { class: "row mx-0 px-0 gx-3 mb-2" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-max-content col-lg-2 col-form-label" }, null, -1))
const _hoisted_75 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_76 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_77 = { class: "col-lg-12" }
const _hoisted_78 = ["placeholder"]
const _hoisted_79 = { class: "row mx-0 px-0 gx-3 pb-4" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3" }, null, -1))
const _hoisted_81 = { class: "col-lg-9 px-3" }
const _hoisted_82 = { class: "fw-bold fs-6 p-2 text-lg-start" }
const _hoisted_83 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_84 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_85 = { class: "w-max-content col-lg-1 col-form-label" }
const _hoisted_86 = { class: "row mx-0 px-0 col-lg-5 align-items-center" }
const _hoisted_87 = { class: "d-flex col-lg-10 px-2 justify-auth" }
const _hoisted_88 = { class: "form-check me-4" }
const _hoisted_89 = { class: "form-check-label" }
const _hoisted_90 = ["value"]
const _hoisted_91 = { class: "form-check me-4" }
const _hoisted_92 = { class: "form-check-label" }
const _hoisted_93 = ["value"]
const _hoisted_94 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_95 = { class: "w-max-content col-lg-3 col-form-label text-black" }
const _hoisted_96 = { class: "row mx-0 px-0 col-lg-9" }
const _hoisted_97 = { class: "d-flex col-12 px-2 flex-xl-row flex-column" }
const _hoisted_98 = { class: "col-12 col-xl-6 me-4" }
const _hoisted_99 = ["title"]
const _hoisted_100 = ["title"]
const _hoisted_101 = {
  key: 2,
  class: "col-lg-5 me-4"
}
const _hoisted_102 = ["disabled"]
const _hoisted_103 = {
  key: 1,
  class: "col-form-label fs-7"
}
const _hoisted_104 = {
  key: 0,
  class: "bg-white shadow rounded-4 p-3 p-lg-5 mb-3 mb-lg-5"
}
const _hoisted_105 = { class: "fw-bold text-center mb-3 mb-lg-5 fs-6" }
const _hoisted_106 = { class: "mb-3 break-word term-of-use" }
const _hoisted_107 = { class: "checkbox-wrapper d-flex justify-content-center align-items-center" }
const _hoisted_108 = ["for"]
const _hoisted_109 = ["id"]
const _hoisted_110 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_111 = { class: "bg-white shadow rounded-4 p-3 p-lg-5 mb-5" }
const _hoisted_112 = { class: "fw-bold text-center mb-3 mb-lg-5 fs-6" }
const _hoisted_113 = { class: "mb-3 break-word term-of-use" }
const _hoisted_114 = { class: "checkbox-wrapper d-flex justify-content-center align-items-center" }
const _hoisted_115 = ["for"]
const _hoisted_116 = ["id"]
const _hoisted_117 = {
  key: 0,
  class: "text-danger text-center"
}
const _hoisted_118 = { class: "d-flex justify-content-center" }

import { computed, ref, watchEffect, onMounted, nextTick, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { translate } from '@/languages/i18n'
import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import useVuelidate from '@vuelidate/core'
import JoinWithAccount from './components/JoinWithAccount.vue'
import { useStore } from 'vuex'
import { USER_STORE } from '@/store/constants'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { PASSWORD_REGEX, SPECIAL_WORDS, REGEX_EMOJI, PASSWORD_FORMAT_REGEX } from '@/constants/regex'
import { required, maxLength, minLength, sameAs, numeric } from '@vuelidate/validators'
import { customMaxLength, scrollToErrors } from '@/utils'
import { DEFAULT_MAX_LENGTH, PASSWORD_MIN_LENGTH, DEFAULT_MIN_LENGTH, DEFAULT_MAX_JP_TEXT } from '@/constants/number'
import dayjs from 'dayjs'
import ErrorMessage from '@/components/error-message'
import { PATH } from '@/constants'
import { getBirthdayConfig } from '@/constants/datepicker'
import { getCookie } from '@/utils'
import flatPickr from 'vue-flatpickr-component'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { getMessage } from '@/constants/messageCode.ts'
import { AuthenMethodTypes } from '@/store/modules/register-alumnus'
import ErrorToast from '@/components/toast-error/indexErrorToast.vue'
import { useToast } from 'vue-toastification'
import { useCountdown } from '@/use/useCountdown'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const disableBtn = ref(true)
const router = useRouter()
const route = useRoute()
const toast = useToast()

const store = useStore()
// 2022/10/19 PhuongTT Show invalid URL message UAT#4632: SB20 (Ph2-R20221021)
// const registerFailed = localStorage.getItem('registerFailed')
// const userParticipant = localStorage.getItem('userParticipant')
// const validateDuplicate = localStorage.getItem('validateDuplicate')
// const validateComunity = localStorage.getItem('validateComunity')
// const userMax = localStorage.getItem('userMax')

const messageCode = localStorage.getItem('validateComunity')

const invited_code = getCookie('invited_code_employee')

const joinUsersData = computed(() => store.getters[USER_STORE.GETTERS.JOIN_USER_VALUE])

const checkSubmit = ref<boolean>(false)
const termsYelloop = computed(() => store.getters[USER_STORE.GETTERS.TERMS_YELLOOP])
const termsCommunity = computed(() => store.getters[USER_STORE.GETTERS.TERMS_COMMUNITY])
const invitedCommunity = computed(() => store.getters[USER_STORE.GETTERS.INVITE_COMMUNITY])
const first_time = ref('')
const invitedCodeNotFound = ref<boolean>(false)
const loading = ref<boolean>(false)
const fullPhoneNumber = computed(() => {
  const p1 = joinUsersData.value.phone_number_1 || '000'
  const p2 = joinUsersData.value.phone_number_2 || '0000'
  const p3 = joinUsersData.value.phone_number_3 || '0000'
  return `${p1}-${p2}-${p3}`
})
const { timeLeft, showCountTime, startCountdown } = useCountdown(`countdownEndTimeSendTest_${route.meta.screenId}`)
const submittingButton = ref<boolean>(false)

onMounted(async () => {
  const path = PATH[`${route.path.split('/')[1]}`]
  store.dispatch(USER_STORE.ACTIONS.SET_TERMS_YELLOOP, 'employee')
  if (getCookie(path.header) && getCookie(path?.pathName)) {
    first_time.value = false
  } else {
    first_time.value = true
  }
  loading.value = true
  try {
    await store.dispatch(USER_STORE.ACTIONS.SET_INVITE_COMMUNITY, invited_code)
    if (invitedCommunity.value?.community_id) {
      store.dispatch(USER_STORE.ACTIONS.SET_TERMS_COMMUNITY, invitedCommunity.value?.community_id)
      // store.dispatch(USER_STORE.ACTIONS.SET_FIRST_TIME, invitedCommunity.value?.community_id)
    } else {
      invitedCodeNotFound.value = true
    }
    setTimeout(() => {
      loading.value = false
    }, [3000])
  } catch (error) {
    console.log(error)
    loading.value = false
  }
})

watchEffect(() => {
  localStorage.removeItem('checkSubmit')
  window.addEventListener('unload', function () {
    // 2022/10/19 PhuongTT Show invalid URL message UAT#4632: SB20 (Ph2-R20221021)
    localStorage.removeItem('validateComunity')
    // localStorage.removeItem('registerFailed')
    // localStorage.removeItem('userParticipant')
    // localStorage.removeItem('userMax')
    // localStorage.removeItem('validateDuplicate')
    // localStorage.removeItem('validateComunity')
  })
})

// const { withAsync } = helpers
// const ngWord = withAsync(async () => {
//   try {
//     const data = await commonService.sendNGWordCheck({ sentence: v$.value.password.$model })
//     return !data.data?.data?.has_ngword
//   } catch (e) {
//     return false
//   }
// })

const rules = computed(() => {
  return {
    family_name: {
      required,
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    given_name: {
      required,
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    family_name_kana: {
      required,
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      fullSizeKatakana: function (value) {
        return /^([ァ-ヶ]|ー)+$/.test(value)
      },
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    given_name_kana: {
      required,
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      minLength: minLength(DEFAULT_MIN_LENGTH),
      fullSizeKatakana: function (value) {
        return /^([ァ-ヶ]|ー)+$/.test(value)
      },
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    password: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      //ngWord,
      containsSpecialWords: function (value) {
        let count = 0
        SPECIAL_WORDS.forEach((e) => {
          if (value === e) count++
        })
        if (count === 0) return true
      },
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
      containsTypeSpecialCharacter: function (value) {
        let count = 0
        ;[...value].forEach((e) => {
          if (PASSWORD_FORMAT_REGEX.test(e)) count++
        })
        if (count === value.length) return true
      },
      containsType: function (value) {
        return PASSWORD_REGEX.test(value)
      },
    },
    birthday: {
      required,
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
    },
    confirmPassword: {
      required,
      maxLength: maxLength(DEFAULT_MAX_LENGTH),
      minLength: minLength(PASSWORD_MIN_LENGTH),
      sameAsPassword: sameAs(formData.value.password),
    },
    phone_number_1: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(5),
    },
    phone_number_2: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(4),
    },
    phone_number_3: {
      required,
      numeric,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: maxLength(4),
    },
    authentication_method: {
      required,
    },
  }
})

const formData = ref(joinUsersData)

const v$ = useVuelidate(rules, formData)

watchEffect(() => {
  if (invitedCommunity.value?.admin) {
    if (formData.value.consent_of_yelloop && formData.value.consent_of_community) {
      disableBtn.value = false
    } else {
      disableBtn.value = true
    }
  } else {
    if (formData.value.consent_of_community) {
      disableBtn.value = false
    } else {
      disableBtn.value = true
    }
  }
})

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  checkSubmit.value = true

  const isCheckedNGItems: Array<{ value: boolean }> = [isCheckedNGFamilyName, isCheckedNGGivenName, isCheckedNGFamilyNameKana, isCheckedNGGivenNameKana]
  isCheckedNGItems.forEach((checkedNGItem) => (checkedNGItem.value = false))
  await Promise.all([checkNGFamilyName(), checkNGGivenName(), checkNGFamilyNameKana(), checkNGGivenNameKana()])
  while (!isCheckedNGItems.every((checkedNGItem) => checkedNGItem.value)) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyFamilyName.value || ngKeyGivenName.value || ngKeyFamilyNameKana.value || ngKeyGivenNameKana.value) {
    nextTick(() => {
      scrollToErrors()
    })
    return
  }
  if (invitedCommunity.value?.admin) {
    if (formData.value.consent_of_yelloop && formData.value.consent_of_community) {
      store.dispatch(USER_STORE.ACTIONS.SET_JOIN_USER_VALUE, formData.value)
      router.push('/community/join_users_confirm')
      localStorage.setItem('checkConfirm', true)
      // 2022/10/19 PhuongTT Show invalid URL message UAT#4632: SB20 (Ph2-R20221021)
      // localStorage.removeItem('registerFailed')
      // localStorage.removeItem('userParticipant')
      // localStorage.removeItem('userMax')
      localStorage.removeItem('validateComunity')
    }
  } else {
    if (formData.value.consent_of_community) {
      store.dispatch(USER_STORE.ACTIONS.SET_JOIN_USER_VALUE, formData.value)
      router.push('/community/join_users_confirm')
      localStorage.setItem('checkConfirm', true)
      // 2022/10/19 PhuongTT Show invalid URL message UAT#4632: SB20 (Ph2-R20221021)
      // localStorage.removeItem('registerFailed')
      // localStorage.removeItem('userParticipant')
      // localStorage.removeItem('userMax')
      localStorage.removeItem('validateComunity')
    }
  }
}

const isCheckedNGFamilyName = { value: false }
const ngKeyFamilyName = ref<boolean>(false)
const checkNGFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.family_name.$model })
  ngKeyFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGFamilyName.value = true
}, 200)

const isCheckedNGGivenName = { value: false }
const ngKeyGivenName = ref<boolean>(false)
const checkNGGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.given_name.$model })
  ngKeyGivenName.value = data.data?.data?.has_ngword
  isCheckedNGGivenName.value = true
}, 200)

const isCheckedNGFamilyNameKana = { value: false }
const ngKeyFamilyNameKana = ref<boolean>(false)
const checkNGFamilyNameKana = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.family_name_kana.$model })
  ngKeyFamilyNameKana.value = data.data?.data?.has_ngword
  isCheckedNGFamilyNameKana.value = true
}, 200)

const isCheckedNGGivenNameKana = { value: false }
const ngKeyGivenNameKana = ref<boolean>(false)
const checkNGGivenNameKana = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.given_name_kana.$model })
  ngKeyGivenNameKana.value = data.data?.data?.has_ngword
  isCheckedNGGivenNameKana.value = true
}, 200)
const sendTestPhoneNumber = debounce(async () => {
  submittingButton.value = true
  const p1 = joinUsersData.value.phone_number_1 || '000'
  const p2 = joinUsersData.value.phone_number_2 || '0000'
  const p3 = joinUsersData.value.phone_number_3 || '0000'
  const phoneNumber = `${p1}${p2}${p3}`
  try {
    const data = await commonService.sendTestPhoneNumber({ phone_number: phoneNumber })
    if (data?.response?.status === 400) {
      scrollToErrors('#phone-number')
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'バリデーションエラー',
        },
      })
      submittingButton.value = false
    } else if (data?.status !== 200) {
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'リクエストエラーが発生しました。しばらく経ってからアクセスしてください。',
        },
      })
      submittingButton.value = false
    } else {
      startCountdown(30)
    }
  } catch (error) {
    toast.error({
      component: ErrorToast,
      props: {
        messageCode: 'リクエストエラーが発生しました。しばらく経ってからアクセスしてください。',
      },
    })
    submittingButton.value = false
  }
}, 200)
watch(showCountTime, (newVal) => {
  submittingButton.value = newVal
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!first_time.value && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(JoinWithAccount)
        ]))
      : _createCommentVNode("", true),
    (first_time.value && !loading.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          class: "container pt-3 pt-lg-5 pb-3 pb-lg-5",
          onSubmit: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString(_unref(invitedCommunity)?.corporation_name) + " " + _toDisplayString(_unref(invitedCommunity)?.community_name) + " " + _toDisplayString(_unref(translate)('SB20heading')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (invitedCodeNotFound.value)
              ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                  key: 0,
                  title: _unref(translate)('INVALID_URL_ERROR')
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_unref(messageCode))
              ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                  key: 1,
                  title: _unref(getMessage)(_unref(messageCode))
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(translate)('SB20title')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('basicInformation')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(translate)('nameKanji')), 1),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('surName')), 1),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "surNameKanji",
                    placeholder: _unref(translate)('placeholder'),
                    class: _normalizeClass(['form-control', ngKeyFamilyName.value || _unref(v$).family_name.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).family_name.$model) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGFamilyName) && _unref(checkNGFamilyName)(...args)))
                  }, null, 42, _hoisted_16), [
                    [
                      _vModelText,
                      _unref(v$).family_name.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (ngKeyFamilyName.value && !_unref(v$).family_name.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: 'surName',
                    params: [1, 20],
                    validator: _unref(v$).family_name.$errors[0]?.$validator
                  }, null, 8, ["validator"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(translate)('name')), 1),
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "lastNameKanji",
                    placeholder: _unref(translate)('placeholder'),
                    class: _normalizeClass(['form-control', ngKeyGivenName.value || _unref(v$).given_name.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).given_name.$model) = $event)),
                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGGivenName) && _unref(checkNGGivenName)(...args)))
                  }, null, 42, _hoisted_21), [
                    [
                      _vModelText,
                      _unref(v$).given_name.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (ngKeyGivenName.value && !_unref(v$).given_name.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('name'),
                    params: [1, 20],
                    validator: _unref(v$).given_name.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(translate)('nameKatakana')), 1),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(translate)('surNameKatakana')), 1),
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "surNameKatakana",
                    placeholder: _unref(translate)('placeholder'),
                    class: _normalizeClass(['form-control', ngKeyFamilyNameKana.value || _unref(v$).family_name_kana.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).family_name_kana.$model) = $event)),
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(checkNGFamilyNameKana) && _unref(checkNGFamilyNameKana)(...args)))
                  }, null, 42, _hoisted_29), [
                    [
                      _vModelText,
                      _unref(v$).family_name_kana.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (ngKeyFamilyNameKana.value && !_unref(v$).family_name_kana.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('surNameKatakana'),
                    params: [1, 20],
                    validator: _unref(v$).family_name_kana.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(translate)('lastNameKatakana')), 1),
                _createElementVNode("div", _hoisted_33, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "lastNameKatakana",
                    placeholder: _unref(translate)('placeholder'),
                    class: _normalizeClass(['form-control', ngKeyGivenNameKana.value || _unref(v$).given_name_kana.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).given_name_kana.$model) = $event)),
                    onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(checkNGGivenNameKana) && _unref(checkNGGivenNameKana)(...args)))
                  }, null, 42, _hoisted_34), [
                    [
                      _vModelText,
                      _unref(v$).given_name_kana.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (ngKeyGivenNameKana.value && !_unref(v$).given_name_kana.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('lastNameKatakana'),
                    params: [1, 20],
                    validator: _unref(v$).given_name_kana.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("label", _hoisted_37, _toDisplayString(_unref(translate)('SB20belong')), 1),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(invitedCommunity)?.department_name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, _toDisplayString(_unref(translate)('email')), 1),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(invitedCommunity)?.email), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(translate)('SB20noticeMail2')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
              _createElementVNode("div", _hoisted_46, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_unref(flatPickr), {
                      modelValue: _unref(v$).birthday.$model,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).birthday.$model) = $event)),
                      config: _unref(getBirthdayConfig)(_unref(v$).birthday.$model),
                      class: _normalizeClass(['form-control bg-white', _unref(v$).birthday.$error ? 'is-invalid' : ''])
                    }, null, 8, ["modelValue", "config", "class"]),
                    _hoisted_50
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('dateOfBirth'),
                    params: [1900, 1, 1],
                    validator: _unref(v$).birthday.$errors[0]?.$validator
                  }, null, 8, ["title", "validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(translate)('PhoneNumber')), 1),
              _createElementVNode("div", _hoisted_53, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: _normalizeClass(['form-control', _unref(v$).phone_number_1.$error ? 'is-invalid' : '']),
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).phone_number_1.$model) = $event))
                    }, null, 2), [
                      [
                        _vModelText,
                        _unref(v$).phone_number_1.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('PhoneNumber1'),
                      params: [_unref(DEFAULT_MIN_LENGTH), 5],
                      validator: _unref(v$).phone_number_1.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"])
                  ]),
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: _normalizeClass(['form-control', _unref(v$).phone_number_2.$error ? 'is-invalid' : '']),
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).phone_number_2.$model) = $event))
                    }, null, 2), [
                      [
                        _vModelText,
                        _unref(v$).phone_number_2.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('PhoneNumber2'),
                      params: [_unref(DEFAULT_MIN_LENGTH), 4],
                      validator: _unref(v$).phone_number_2.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"])
                  ]),
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      class: _normalizeClass(['form-control', _unref(v$).phone_number_3.$error ? 'is-invalid' : '']),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).phone_number_3.$model) = $event))
                    }, null, 2), [
                      [
                        _vModelText,
                        _unref(v$).phone_number_3.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('PhoneNumber3'),
                      params: [_unref(DEFAULT_MIN_LENGTH), 4],
                      validator: _unref(v$).phone_number_3.$errors[0]?.$validator
                    }, null, 8, ["title", "params", "validator"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("label", _hoisted_62, _toDisplayString(_unref(translate)('SA20passwordSecret')), 1)
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("label", _hoisted_64, _toDisplayString(_unref(translate)('password')), 1),
              _createElementVNode("div", _hoisted_65, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("input", {
                    type: "email",
                    autocomplete: "username",
                    style: {"display":"none"},
                    value: _unref(invitedCommunity)?.email
                  }, null, 8, _hoisted_68),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    name: "password",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).password.$model) = $event)),
                    class: _normalizeClass(['form-control', _unref(v$).password.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder')
                  }, null, 10, _hoisted_69), [
                    [
                      _vModelText,
                      _unref(v$).password.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: 'password',
                    params: [8, 128],
                    validator: _unref(v$).password.$errors[0]?.$validator
                  }, null, 8, ["validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _hoisted_71,
              _createElementVNode("div", _hoisted_72, _toDisplayString(_unref(translate)('SB20noticePass')), 1)
            ]),
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createElementVNode("div", _hoisted_75, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    name: "confirmPassword",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(v$).confirmPassword.$model) = $event)),
                    class: _normalizeClass(['form-control', _unref(v$).confirmPassword.$error ? 'is-invalid' : '']),
                    placeholder: _unref(translate)('placeholder')
                  }, null, 10, _hoisted_78), [
                    [
                      _vModelText,
                      _unref(v$).confirmPassword.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: 'password',
                    params: [8, 128],
                    validator: _unref(v$).confirmPassword.$errors[0]?.$validator
                  }, null, 8, ["validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_79, [
              _hoisted_80,
              _createElementVNode("div", _hoisted_81, _toDisplayString(_unref(translate)('SB20noticePassConfirm')), 1)
            ]),
            _createElementVNode("h3", _hoisted_82, _toDisplayString(_unref(translate)('twoFA')), 1),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("label", _hoisted_84, _toDisplayString(_unref(translate)('method')), 1),
              _createElementVNode("div", _hoisted_85, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_86, [
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("label", _hoisted_89, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "authentication_method",
                        value: _unref(AuthenMethodTypes).SMS,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(v$).authentication_method.$model) = $event))
                      }, null, 8, _hoisted_90), [
                        [_vModelRadio, _unref(v$).authentication_method.$model]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('useSMS')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("label", _hoisted_92, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        name: "authentication_method",
                        value: _unref(AuthenMethodTypes).EMAIL,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(v$).authentication_method.$model) = $event))
                      }, null, 8, _hoisted_93), [
                        [_vModelRadio, _unref(v$).authentication_method.$model]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('useEmail')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("label", _hoisted_95, _toDisplayString(_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('phone') : _unref(translate)('email')), 1),
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(['form-control', 'show-info-field']),
                          name: "phone",
                          title: _unref(fullPhoneNumber)?.trim()
                        }, _toDisplayString(_unref(fullPhoneNumber) || _unref(translate)(`phoneExample`)), 9, _hoisted_99))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(['form-control', 'show-info-field']),
                          name: "email",
                          title: formData.value.email?.trim()
                        }, _toDisplayString(_unref(invitedCommunity)?.email || 'sample@yelloop.jp'), 9, _hoisted_100)),
                    _createElementVNode("div", {
                      class: _normalizeClass(['col-lg-12 col-form-label while-spaces', { 'text-danger': _unref(v$).authentication_method.$model === _unref(AuthenMethodTypes).SMS }])
                    }, _toDisplayString(_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL ? _unref(translate)('showPhoneMessage') : _unref(translate)('showRegisteredEmailMessage')), 3),
                    (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                          (_unref(v$).authentication_method.$model !== _unref(AuthenMethodTypes).EMAIL)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "button-test shadow button-router-link",
                                disabled: 
                    _unref(v$).phone_number_1.$error ||
                    _unref(v$).phone_number_2.$error ||
                    _unref(v$).phone_number_3.$error ||
                    !_unref(v$).phone_number_1.$model ||
                    !_unref(v$).phone_number_2.$model ||
                    !_unref(v$).phone_number_3.$model ||
                    _unref(showCountTime) ||
                    submittingButton.value
                  ,
                                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_unref(sendTestPhoneNumber) && _unref(sendTestPhoneNumber)(...args)))
                              }, _toDisplayString(_unref(translate)('testSend')), 9, _hoisted_102))
                            : _createCommentVNode("", true),
                          (_unref(showCountTime))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_103, _toDisplayString(_unref(timeLeft)) + "秒後に再送可能です ", 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          (_unref(invitedCommunity)?.admin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                _createElementVNode("h1", _hoisted_105, _toDisplayString(_unref(translate)('SB20term1')), 1),
                _createElementVNode("div", _hoisted_106, _toDisplayString(_unref(termsYelloop)?.content), 1),
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("label", {
                    for: _ctx.agreeWithTerm,
                    class: "mt-1 ms-2"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      id: _ctx.agreeWithTerm,
                      type: "checkbox",
                      class: "mr-1 cursor-pointer form-check-input",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.consent_of_yelloop) = $event))
                    }, null, 8, _hoisted_109), [
                      [_vModelCheckbox, formData.value.consent_of_yelloop]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('SB20agreeWithTerm')), 1)
                  ], 8, _hoisted_108)
                ]),
                (!formData.value.consent_of_yelloop && checkSubmit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_110, _toDisplayString(_unref(translate)('SA20yelloopError')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("h1", _hoisted_112, _toDisplayString(_unref(invitedCommunity)?.community_name) + _toDisplayString(_unref(translate)('agreeLeaderShipSB20')), 1),
            _createElementVNode("div", _hoisted_113, _toDisplayString(_unref(termsCommunity)?.term_of_service), 1),
            _createElementVNode("div", _hoisted_114, [
              _createElementVNode("label", {
                for: _ctx.agreeTerm3,
                class: "mt-1 ms-2"
              }, [
                _withDirectives(_createElementVNode("input", {
                  id: _ctx.agreeTerm3,
                  type: "checkbox",
                  class: "mr-1 cursor-pointer form-check-input",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.consent_of_community) = $event))
                }, null, 8, _hoisted_116), [
                  [_vModelCheckbox, formData.value.consent_of_community]
                ]),
                _createTextVNode(" " + _toDisplayString(_unref(invitedCommunity)?.community_name) + _toDisplayString(_unref(translate)('agreeLeaderShip')), 1)
              ], 8, _hoisted_115)
            ]),
            (!formData.value.consent_of_community && checkSubmit.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(_unref(invitedCommunity)?.community_name) + _toDisplayString(_unref(translate)('SA20communityError')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_118, [
            _createVNode(Button, {
              title: _unref(translate)('confirm'),
              type: 'secondary',
              onClick: onSubmit,
              disabled: disableBtn.value
            }, null, 8, ["title", "disabled"])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ], 64))
}
}

})